export function parsePlaceholder(str: string) {
  const match = str.match(/"([^"]*)"/);

  return match ? match[1] : '';
}
